/* JB | brindes na página de produto: o app coloca o bloco dentro da coluna do botão de comprar,
   ao lado da quantidade. Aqui ele vai para cima da linha quantidade + botão, em largura total. */
(function () {
  if (window.__jbBrindesProduto) return;
  window.__jbBrindesProduto = true;

  function mover() {
    document.querySelectorAll('.gfgProductPageWrapperV2').forEach((bloco) => {
      const coluna = bloco.parentElement;
      if (!coluna || !coluna.classList.contains('buy-button-flex-item')) return;
      const linha = coluna.closest('.quantity-buy-flex-container');
      if (!linha || !linha.parentElement) return;
      linha.parentElement.insertBefore(bloco, linha);
    });
  }

  let agendado = false;
  const observar = () => {
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(() => {
      agendado = false;
      mover();
    });
  };
  const iniciar = () => {
    mover();
    new MutationObserver(observar).observe(document.body, { childList: true, subtree: true });
  };
  if (document.body) iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar);
})();
